module.exports = __webpack_public_path__ + "static/img/mobil-notification.801952ff.svg";